var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3105 6.88826C15.05 -1.52005 7.51469 -1.52005 0.257249 6.88826C0.170184 6.98879 0.117188 7.12232 0.117188 7.26735C0.117188 7.41239 0.170184 7.54592 0.258006 7.64721C3.88673 11.8518 7.5957 13.982 11.2827 13.982C14.969 13.982 18.681 11.851 22.3097 7.64645C22.3975 7.54592 22.4505 7.41316 22.4505 7.26735C22.4505 7.12155 22.3975 6.98879 22.3089 6.8875L22.3105 6.88826ZM1.44512 7.26735C8.03481 -0.119557 14.5359 -0.116487 21.1233 7.26735C14.5344 14.6504 8.03254 14.6504 1.44512 7.26735ZM11.2842 3.62225C9.29839 3.62225 7.68807 5.25449 7.68807 7.26735C7.68807 9.28022 9.29839 10.9125 11.2842 10.9125C13.2701 10.9125 14.8804 9.28022 14.8804 7.26735C14.8781 5.25525 13.2693 3.62455 11.2842 3.62225ZM11.2842 9.76138C9.92526 9.76138 8.8237 8.64482 8.8237 7.26735C8.8237 5.88989 9.92526 4.77333 11.2842 4.77333C12.6432 4.77333 13.7448 5.88989 13.7448 7.26735C13.7433 8.64406 12.6424 9.75984 11.2842 9.76138Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6ca128c5f0095c6204830435c91942de.svg";
export { ForwardRef as ReactComponent };